import html from './playerIndicator.html';
import {partial} from '../../../utils/partial';
import {getLanguage} from '../../../configs/global';
import {TweenMax} from 'gsap';
import Draggable from 'gsap/Draggable';
import {Emitter, EVENTS} from '../../../utils/emitter';
import Mustache from 'mustache';
import data from '../../../configs/copy';

export class PlayerIndicator extends Emitter {
  [x: string]: any;
  public element: HTMLElement;
  public hitarea: HTMLElement;
  private radius: number;
  private circle: SVGCircleElement;

  private circumference: number;
  private playIcon: HTMLElement;
  private pauseIcon: HTMLElement;
  private controller: HTMLElement;
  private controllerKnob: HTMLElement;
  private draggable: any;

  private playCopy: HTMLElement;
  private pauseCopy: HTMLElement;
  private introCopy: HTMLElement;

  constructor(parent: HTMLElement) {
    super();

    this.element = partial(Mustache.render(html, data[getLanguage()]), '.playerIndicator');
    parent.appendChild(this.element);

    this.circle = this.element.querySelector('circle');
    this.playIcon = this.element.querySelector('.playIcon');
    this.playCopy = this.element.querySelector('.copy--play');
    this.pauseIcon = this.element.querySelector('.pauseIcon');
    this.pauseCopy = this.element.querySelector('.copy--pause');
    this.introCopy = this.element.querySelector('.copy--intro');
    this.controller = this.element.querySelector('.controller');
    this.controllerKnob = this.element.querySelector('.controllerKnob');
    this.hitarea = this.element.querySelector('.hitarea');
    this.radius = this.circle.r.baseVal.value;
    this.circumference = this.radius * 2 * Math.PI;

    this.circle.style.strokeDasharray = `${this.circumference} ${this.circumference}`;
    this.circle.style.strokeDashoffset = `${this.circumference}`;

    TweenMax.set([this.pauseCopy, this.playCopy, this.pauseIcon], {opacity: 0});

    this.initController();
  }

  private initController() {
    this.draggable = Draggable.create(this.controller, {
      type: 'rotation',
      trigger: this.controllerKnob,
      bounds: {maxRotation: 360, minRotation: 0},
      onDrag: () => {
        this.setProgress((this.draggable[0].rotation / 360) * 100);
      },
      onDragEnd: () => this.emit(EVENTS.progress, {progress: this.draggable[0].rotation / 360})
    });
  }

  public showPlay() {
    // Icon
    TweenMax.to(this.pauseIcon, 0.15, {opacity: 0});
    TweenMax.to(this.playIcon, 0.15, {opacity: 1, delay: 0.1});

    // Copy
    TweenMax.to(this.playCopy, 0.15, {opacity: 1, y: 0});
    TweenMax.to([this.pauseCopy, this.introCopy], 0.15, {opacity: 0, y: 5});
  }

  public showPause() {
    // Icon
    TweenMax.to(this.pauseIcon, 0.15, {opacity: 1, delay: 0.1});
    TweenMax.to(this.playIcon, 0.15, {opacity: 0});

    // Copy
    TweenMax.to([this.playCopy, this.introCopy], 0.15, {opacity: 0, y: -5});
    TweenMax.to(this.pauseCopy, 0.15, {opacity: 1, y: 0});
  }

  public setProgress(percent) {
    const offset = this.circumference - (percent / 100) * this.circumference;
    this.circle.style.strokeDashoffset = String(offset);
    TweenMax.set(this.controller, {rotation: 360 * (percent / 100)});
  }

  public kill() {}
}
